document.addEventListener("DOMContentLoaded",()=>{

/* ELEMENTEN */

const openBtn=document.getElementById("tiflieOpen");
const closeBtn=document.querySelector(".tiflie-close");

const drawer=document.querySelector(".tiflie-drawer");
const overlay=document.getElementById("tiflieOverlay");

const applyBtn=document.getElementById(
"tiflieApplyFilters"
);

const minSlider=document.getElementById(
"priceMin"
);

const maxSlider=document.getElementById(
"priceMax"
);

const minInput=document.getElementById(
"priceMinInput"
);

const maxInput=document.getElementById(
"priceMaxInput"
);

const sortSelect=document.querySelector(
'#tiflieFilterForm select[name="sort_by"]'
);


if(!drawer || !overlay) return;


/* PRODUCT AANTAL */

/* DYNAMISCHE RESULTATEN TELLER */

function updateResultsCount(){

if(!applyBtn) return;

const min =
parseFloat(minInput?.value || 0);

const max =
parseFloat(maxInput?.value || 999999);

let count = 0;

document.querySelectorAll(
'.tiflie-card'
).forEach(card=>{

const priceEl=
card.querySelector(
'.tiflie-current-price'
);

if(!priceEl) return;

const price=
parseFloat(
priceEl.textContent
.replace('€','')
.replace(',','.')
.trim()
);

if(
price >= min &&
price <= max
){
count++;
}

});

applyBtn.textContent=
`Bekijk resultaten (${count})`;

}


/* direct uitvoeren */

updateResultsCount();


/* opnieuw uitvoeren bij slider */

[minSlider,maxSlider,minInput,maxInput]
.forEach(el=>{

el?.addEventListener(
'input',
updateResultsCount
);

});


/* DRAWER NAAR BODY */

document.body.appendChild(drawer);
document.body.appendChild(overlay);


/* OPEN */

openBtn?.addEventListener(
"click",
()=>{

drawer.classList.add(
"active"
);

overlay.classList.add(
"active"
);

document.body.style.overflow=
"hidden";

}
);


/* CLOSE */

function closeDrawer(){

drawer.classList.remove(
"active"
);

overlay.classList.remove(
"active"
);

document.body.style.overflow=
"";

}

closeBtn?.addEventListener(
"click",
closeDrawer
);

overlay?.addEventListener(
"click",
closeDrawer
);


/* PRIJS SLIDER */

if(
minSlider &&
maxSlider &&
minInput &&
maxInput
){

minSlider.addEventListener(
"input",
()=>{

if(
+minSlider.value >=
+maxSlider.value
){

minSlider.value=
+maxSlider.value-1;

}

minInput.value=
minSlider.value;

}
);

maxSlider.addEventListener(
"input",
()=>{

if(
+maxSlider.value <=
+minSlider.value
){

maxSlider.value=
+minSlider.value+1;

}

maxInput.value=
maxSlider.value;

}
);

}


/* FILTER TOEPASSEN */

applyBtn?.addEventListener(
"click",
()=>{

const params=
new URLSearchParams(
window.location.search
);


/* sortering */

if(
sortSelect &&
sortSelect.value
){

params.set(
"sort_by",
sortSelect.value
);

}


/* prijs */

if(minInput){

params.set(
minInput.name,
minInput.value
);

}

if(maxInput){

params.set(
maxInput.name,
maxInput.value
);

}


/* voorraad */

document.querySelectorAll(
'#tiflieFilterForm input[type="checkbox"]:checked'
).forEach(el=>{

params.set(
el.name,
el.value
);

});


window.location.href=
window.location.pathname +
"?" +
params.toString();

}
);


/* FILTERS RESETTEN */

document.querySelectorAll(
'.active-facets__button,.active-facets__clear'
).forEach(btn=>{

btn.addEventListener(
'click',
closeDrawer
);

});


/* PAGINA TERUGKOMT */

window.addEventListener(
'pageshow',
closeDrawer
);

});

